import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { type AppRoutes, ROUTES } from '../../common/constants/defaultStaticUrls';

const routeProgressMapping: Record<string, number> = {
  [ROUTES.HOME]: 0,
  [ROUTES.PLATE_NUMBER_ERROR]: 33,
  [ROUTES.LOCALIZATION_ERROR]: 33,
  [ROUTES.SUCCESS]: 100,
};

const getRouteCompletionPercentage = (pathname: AppRoutes): number => routeProgressMapping[pathname] ?? 0;

export const useCalculatedProgress = (): number => {
  const { pathname } = useLocation();

  const [progress, setProgress] = useState(getRouteCompletionPercentage(pathname as AppRoutes));
  const clearProgress = (): void => setProgress(0);

  useEffect(() => {
    setProgress(getRouteCompletionPercentage(pathname as AppRoutes));

    return clearProgress;
  }, [pathname]);

  return progress;
};
